export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_RESPONSE = "LOGIN_RESPONSE";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const API_ERROR = "API_ERROR";
export const SOCIAL_LOGIN = "SOCIAL_LOGIN";
export const CLEAR_LOGIN_ERROR = "CLEAR_LOGIN_ERROR";